import { Franchise } from "~/components/organisms/FranchiseArea"
import { SystemInfo } from "~/components/organisms/SystemInfoArea"
import { ID } from "~/models/Identification"
import { FirstSection, SecondSection } from "~/models/Product"

export const IndustryType = {
  Maintenance: "1",
  Repair: "2",
  Service: "3",
  CarSales: "4",
  None: "99",
} as const

export interface Industry {
  question: ID,
  systemOrders: ID[],
  franchise: Franchise,
  systemInfo: SystemInfo
}

export type IndustryTypeKey = keyof typeof IndustryType
export type IndustryTypeValue = typeof IndustryType[IndustryTypeKey]

export type Industries = {
  [key in IndustryTypeValue]?: Industry
}

export const marketPlaceIndustries = [
  IndustryType.Maintenance,
  IndustryType.Repair,
  IndustryType.Service,
]

export const broadLeafPayIndustries = [
  IndustryType.Maintenance,
  IndustryType.Repair,
  IndustryType.Service,
]

export const priceBoardServiceIndustries = [
  IndustryType.CarSales,
]

export const isIndustry = (firstSections: FirstSection[], secondSections: SecondSection[]) => ({ section1, section2 }: {
  section1: FirstSection
  section2: SecondSection
}) => firstSections.includes(section1) && secondSections.includes(section2)

export const hasOnlyIndustry = (industries: IndustryTypeValue[], type: IndustryTypeValue) => {
  return (industries.length === 1 && (industries[0] === type))
}
